import { createSlice } from '@reduxjs/toolkit';
import { fetchFiles, uploadFile, deleteFile, getFileById, updateFile } from './action';

const slice = createSlice({
  name: 'fileStore',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
    focused: null, // last fetched file (with base64)
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFiles.pending, (state) => { state.status = 'loading'; })
      .addCase(fetchFiles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload || [];
      })
      .addCase(fetchFiles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch files';
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        if (action.payload) state.data.unshift(action.payload);
      })
      .addCase(deleteFile.fulfilled, (state, action) => {
        const id = action.payload;
        state.data = state.data.filter(f => f._id !== id && f.id !== id);
      })
      .addCase(getFileById.fulfilled, (state, action) => {
        state.focused = action.payload;
      })
      .addCase(updateFile.fulfilled, (state, action) => {
        const updated = action.payload;
        const id = updated?._id;
        if (!id) return;
        const idx = state.data.findIndex(f => (f._id || f.id) === id);
        if (idx !== -1) state.data[idx] = { ...state.data[idx], ...updated };
      });
  }
});

export default slice.reducer;
